<div class="container">
    <div class="half-container">
        <p class="main-title">{{"TITLE_ALERT" | translate}}</p>
        <p class="main-subtitle">{{"SUBTITLE_ALERT" | translate}}</p>
    </div>
    <div class="half-container">
    </div>
</div>
<div class="main-container">
    <div class="cameras-container">
        <div class="camera-item" #firstCamera *ngFor="let camera of cameras" (click)="cameraClick(camera)">
            <div [ngClass]="{
                'selected-camera': camera.id == this.currentCameraCell
        }" class="camera-container">
                <span class="title">{{camera.name}}</span>
                <span class="image"></span>
            </div>
        </div>
    </div>
    <div class="event-types-container">
        <neoris-grid  [ColumnsConfiguration]="eventTypesGridColumnsConfiguration" [GridTitle]="eventTypeGridTitle"
            [Data]="dataEventTypes" (cellClickEvent)="EventTypesCellClick($event)" (addClickEvent)="EventTypesAddClick($event)" (saveChangesEvent)="EventTypesSaveChanges($event)" [Filter]="gFilter" [GridSources]="eventTypesGridSource"
            [ShowChecks]="false"></neoris-grid>
    </div>
    <div class="contactos-container">
       <neoris-grid [ColumnsConfiguration]="contactosGridColumnsConfiguration" [GridTitle]="contactosGridTitle"
            [Data]="dataContactos" (cellClickEvent)="ContactosCellClick($event)" (addClickEvent)="ContactosAddClick($event)" (saveChangesEvent)="contactosSaveChanges($event)" [Filter]="gFilter" [GridSources]="contactosGridSource"
            [ShowChecks]="false"></neoris-grid>
    </div>
</div>